import { Modal } from "react-bootstrap";
import styled from "styled-components";

const StyledCustomModal = styled(Modal)`
	background-color: var(--color-black-overlay-45);

	.modal-body {
		padding: 0;
		overflow-y: auto;
	}

	.modal-body-container {
		padding: 16px 16px 16px 32px;
	}

	.modal-dialog {
		max-width: 1188px;
	}

	.modal-content {
		border: none;
		background-color: var(--color-white);
		box-shadow:
			var(--shadow-modal-layer-1),
			var(--shadow-modal-layer-2),
			var(--shadow-modal-layer-3);
		width: ${(props) => props.width || "1188px"} !important;
		margin: 0 auto;
		border-radius: 8px;

		.modal-header {
			border: none;
			background: var(--color-pale-grey);
			display: flex;
			flex-shrink: 0;
			align-items: center;
			justify-content: space-between;
			padding: 16px 16px 8px 32px;

			.main-title-wrapper {
				display: flex;
				flex-direction: column;
				align-items: center;
			}

			.subHeading {
				margin-top: 2px;
			}
		}
	}

	.modal-footer {
		border-top: 0.5px solid var(--color-light-grey);
		background: var(--color-white);
		padding: 12px 32px;
		display: flex;
		align-items: center;
		gap: 8px;
		width: 100%;

		* {
			margin: 0;
		}

		.action-btns {
			display: flex;
			gap: 8px;
			margin-left: auto;
		}
	}
`;

export default StyledCustomModal;
